import { BUTTON_VARIANTS, Button } from "../components/Button";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
export const ICON_BUTTON_VARIANTS = BUTTON_VARIANTS;
const iconButtonVariants = cva("transition-all ease-out duration-300 cursor-pointer hover:scale-110", {
  variants: {
    variant: {
      primary: cn("text-highlight-500", "hover:text-highlight-400", "active:text-highlight-dark", "text-muted-foreground"),
      warning: cn("text-warning-500", "hover:text-warning-400", "active:text-warning-600", "text-muted-foreground"),
      "warning-secondary": cn("text-warning-500", "hover:text-warning-400", "active:text-warning-600", "text-muted-foreground"),
      highlight: cn("text-foreground", "hover:text-highlight-400", "active:text-highlight-dark", "text-muted-foreground"),
      "highlight-secondary": cn("text-foreground", "hover:text-highlight-400", "active:text-highlight-dark", "text-muted-foreground"),
      outline: cn("text-primary-700", "hover:text-faint", "active:text-highlight-dark", "text-muted-foreground"),
      ghost: cn("text-background", "hover:text-primary-100", "active:text-primary-200", "text-background/50"),
      "ghost-secondary": cn("text-white", "hover:text-primary-100", "active:text-primary-200", "text-background/50"),
      "highlight-ghost": cn("text-highlight-500", "hover:text-highlight-400", "active:text-highlight-dark", "text-muted-foreground"),
      "warning-ghost": cn("text-warning-500", "hover:text-warning-400", "active:text-warning-600", "text-muted-foreground")
    }
  },
  defaultVariants: {
    variant: "outline"
  }
});
/**
 * A compact, label-less button rendered as a single icon.
 *
 * @deprecated Use Button with an `icon` and no `label` instead (pass a
 * `tooltip` to keep the action accessible), e.g.
 * `<Button icon={Settings01} tooltip="Settings" variant="ghost" size="sm" />`.
 *
 * @summary Deprecated icon-only button — use Button with an icon.
 */
const IconButton = React.forwardRef(({
  variant = "outline",
  onClick,
  disabled = false,
  tooltip,
  icon,
  className,
  size = "sm",
  ...props
}, ref) => /*#__PURE__*/React.createElement(Button, {
  tooltip: tooltip,
  className: cn(iconButtonVariants({
    variant
  }), disabled && cn("text-primary-500", "cursor-default hover:scale-100"), className),
  onClick: onClick,
  disabled: disabled,
  ref: ref,
  size: size,
  icon: icon,
  variant: "ghost",
  ...props
}));
IconButton.displayName = "IconButton";
export { IconButton, iconButtonVariants };
//# sourceMappingURL=IconButton.js.map